import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-member-select-field', {
  mixins: [eventListenerMixin],

  ready() {
    this.selector = this.querySelector('tr-combo-select-field');
    this.selectedItems = this.querySelector('.selected-items');

    this.listenTo(this.selector, {
      'tr-combo-select-field:change': this.renderSelectedItems.bind(this),
    });

    this.listenTo(this.selectedItems, {
      click: this.handleSelectedItemClick.bind(this),
    });

    this.renderSelectedItems();
  },

  disconnected() {
    this.stopListening();
  },

  renderSelectedItems() {
    const { selectedOptions } = this.selector;
    const selectedItems = document.createDocumentFragment();

    selectedOptions.forEach((option) => {
      selectedItems.appendChild(this.renderSelectedItem(option));
    });

    while (this.selectedItems.firstChild) {
      this.selectedItems.removeChild(this.selectedItems.firstChild);
    }

    this.selectedItems.appendChild(selectedItems);
  },

  handleSelectedItemClick(event) {
    const link = closest(event.target, '.link-remove');
    const selectedItem = closest(link, '.selected-item');

    if (link && selectedItem) {
      this.selectedItems.removeChild(selectedItem);

      const { selectedOptions } = this.selector;
      const option = selectedOptions.find(s => s.value === selectedItem.dataset.value);
      if (option) {
        this.selector.unselectOption(option);
      }
    }
  },

  renderSelectedItem(item) {
    const result = document.createElement('div');
    result.classList.add('selected-item');
    result.dataset.value = item.value;

    if (item.data.icon) {
      result.insertAdjacentHTML('beforeend', `
        <div class="icon"><i class="twr twr-${item.data.icon}"></i></div>
        <div class="content">
          <div class="name">${item.text}</div>
        </div>
      `);
    } else {
      result.insertAdjacentHTML('beforeend', `
        <img src="${item.data.avatar}" alt="${item.text}" class="avatar" />
        <div class="content">
          <div class="name" title="${item.text}">${item.text}</div>
          <div class="team-role ${item.data['team-role'] || ''}">
            ${item.data['team-role-text']}
          </div>
        </div>
      `);
    }

    result.insertAdjacentHTML('beforeend', `
      <a href="javascript:;" class="link-remove"><i class="twr twr-resource-del"></i></a>
    `);

    return result;
  },
});
